import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { connect } from "react-redux";

import ModalMasterDetailView from "../../components/modal/ModalMasterDetailView";
import { colorOperations } from "../../modules/definition/colors";
import { PropTypeShapes } from "../../types";
import SettingsColorDetailView from "./SettingsColorDetailView";
// import ModalRow from "../../components/modal/ModalRow";
// import ModalField from "../../components/modal/ModalField";
// import ModalGroup from "../../components/modal/ModalGroup";
// import ModalTabContent from "../../components/modal/ModalTabContent";
// import ModalFormDropdown from "../../components/form/ModalFormDropdown";

const listItems = props => {
  return props.colors.allIds
    .map(cId => {
      const c = props.colors.byId.get(cId);
      return {
        label: c.label,
        value: c.id,
        color: c.swatchColor,
        canDelete: true
      };
    })
    .toArray();
};

class SettingsColorsTab extends PureComponent {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    // console.log(null[0]);

    const items = listItems(this.props);
    return (
      <ModalMasterDetailView
        items={items}
        onItemSelect={this.selectItem}
        onAddClick={this.props.onAddColor}
        onDeleteClick={this.props.onRemoveColor}
        allowDrag={true}
        onMoveItemAtIndex={this.props.onMoveColor}
        backText="Colors"
        itemsUseIndexAsId={false}
        //#!if iOS === true
// onDoneClick={this.props.onDoneClick}
        //#!endif
      >
        <SettingsColorDetailView {...this.props} />
      </ModalMasterDetailView>
    );
  }
}

SettingsColorsTab.propTypes = {
  colors: PropTypeShapes.colorDefinitionsIdList.isRequired,
  dispatchLocal: PropTypes.func.isRequired,
  onLabelChange: PropTypes.func.isRequired,
  onColorChange: PropTypes.func.isRequired,
  onAddColor: PropTypes.func.isRequired,
  onMoveColor: PropTypes.func.isRequired,
  selectedItem: PropTypes.string,
  onRemoveColor: PropTypes.func.isRequired,
  //#!if iOS === true
// onDoneClick: PropTypes.func.isRequired
  //#!endif
};

const mapDispatchToProps = (_dispatch, props) => {
  // Note: We are always using dispatchLocal here so that the action only travels
  // back to the Settings Modal.
  // Changes are committed to the root store only when the dialog is confirmed.
  return {
    onColorChange: (colorId, icon) => {
      props.dispatchLocal(colorOperations.changeColor(colorId, icon));
    },
    onLabelChange: (colorId, label) => {
      props.dispatchLocal(colorOperations.changeLabel(colorId, label));
    },
    onAddColor: () => {
      props.dispatchLocal(colorOperations.createColor());
    },
    onRemoveColor: colorId => {
      props.dispatchLocal(colorOperations.deleteColor(colorId));
    },
    onMoveColor: (from, to) => {
      props.dispatchLocal(colorOperations.moveColor(from, to));
    }
  };
};

export default connect(null, mapDispatchToProps)(SettingsColorsTab);
